import { Dispatch, SetStateAction, createContext } from "react";

export const LoadingSpinnerContext = createContext(
  {} as {
    isLoading: boolean;
    setIsLoading: Dispatch<SetStateAction<boolean>>;
  },
);
